import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

// A wrapper around clsx and twMerge to combine class names and merge them with tailwind-merge
// Inspiration from https://github.com/shadcn-ui/ui/blob/main/apps/v4/lib/utils.ts#L4
export function cn(...inputs: ClassValue[]) {
	return twMerge(clsx(inputs));
}
